import isObject from 'lodash/isObject';
import {
	ART_DIRECTORY,
	DEFAULT_PIECE
} from 'constants';

export function getImageSrc(work, imgType){
	if (!isObject(work)){
		return `${ART_DIRECTORY}${work}`;
	}
	else{
		return `${ART_DIRECTORY}${
			imgType === 'thumb' || imgType === true
			? work.thumbnail
			: work.filename
		}`;	
	}
}

export function idFromPath(path){
	let id = "";
	if (path){
		let idMatch = /\/([a-zA-Z0-9]*)$/;
		let matches = idMatch.exec(path);
		if (matches && matches[1]){
			id = matches[1];
		}
		if (id === 'gallery'){
			id = DEFAULT_PIECE;
		}
	}
	return id;
}